export const fr = {
  common: {
    appName: 'Moussenaires',
    loading: 'Chargement…',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    close: 'Fermer',
    confirm: 'Confirmer',
    back: 'Retour',
    search: 'Rechercher',
    optional: 'optionnel',
    somethingWrong: "Une erreur s'est produite",
    retry: 'Réessayer',
    empty: 'Rien à afficher pour le moment.',
    yes: 'Oui',
    no: 'Non',
    online: '{{count}} en ligne',
  },
  nav: {
    roster: 'Effectif',
    feed: 'Forum',
    admin: 'Administration',
    login: 'Connexion',
    logout: 'Déconnexion',
    profile: 'Profil',
    settings: 'Paramètres',
    notifications: 'Notifications',
  },
  auth: {
    title: 'Connexion',
    subtitle: 'Un espace privé pour la guilde.',
    username: "Nom d'utilisateur",
    password: 'Mot de passe',
    submit: 'Se connecter',
    invalidCredentials: 'Identifiant ou mot de passe incorrect.',
    rateLimited: 'Trop de tentatives, réessaie dans quelques minutes.',
    impersonating: 'Vous consultez le site en tant que {{username}}.',
    stopImpersonating: 'Revenir à mon compte',
  },
  roster: {
    title: 'Effectif',
    subtitle: 'Les joueurs, leurs personnages et leurs exploits.',
    private: 'Cet effectif est privé — connecte-toi pour le consulter.',
    players: 'Joueurs',
    playerCount: '{{count}} joueur',
    playerCount_other: '{{count}} joueurs',
    characterCount: '{{count}} personnage',
    characterCount_other: '{{count}} personnages',
    rerolls: '{{count}} reroll',
    rerolls_other: '{{count}} rerolls',
    avgItemLevel: "Niveau d'objet moyen",
    bestScore: 'Meilleur score M+',
    main: 'Titulaire',
    reroll: 'Reroll',
    alt: 'Alt',
    bank: 'Banque',
    tank: 'Tank',
    healer: 'Soin',
    dps: 'Dégâts',
    itemLevel: 'ILvl',
    mythicPlusScore: 'Score M+',
    tenPlusKeys: 'Clés 10+',
    bestKeyLevel: 'Meilleure clé',
    progress: 'Progression',
    achievementPoints: 'Hauts faits',
    pvpRating: 'Cote JcJ',
    logs: 'Journaux de combat',
    addLog: 'Ajouter un journal',
    noLogs: 'Aucun journal pour le moment.',
    noCharacters: 'Aucun personnage pour le moment.',
    addPlayer: 'Ajouter un joueur',
    addCharacter: 'Ajouter un personnage',
    editPlayer: 'Modifier le joueur',
    editCharacter: 'Modifier le personnage',
    deletePlayerConfirm: 'Supprimer {{name}} et tous ses personnages ?',
    deleteCharacterConfirm: 'Supprimer {{name}} ?',
    name: 'Nom',
    realm: 'Royaume',
    class: 'Classe',
    spec: 'Spécialisation',
    race: 'Race',
    faction: 'Faction',
    level: 'Niveau',
    role: 'Rôle',
    kind: 'Type',
    notes: 'Notes',
    profileUrl: 'Lien de profil',
    bio: 'Biographie',
    linkedAccount: 'Compte lié',
    notSyncedYet: 'Pas encore synchronisé',
    quickAddHint: 'Le reste (classe, équipement, score…) est récupéré automatiquement après ajout.',
    addAndSync: 'Ajouter et synchroniser',
    syncing: 'Synchronisation…',
    syncComplete: 'Synchronisé',
    syncingHint: 'Récupération des données Armory, Raider.IO et Warcraft Logs…',
    sync: 'Synchroniser',
    lastSynced: 'Synchronisé {{time}}',
    equipment: 'Équipement',
    mythicPlus: 'Mythique+',
    recentRuns: 'Dernières clés',
    bestRuns: 'Meilleures clés',
    inTime: 'Dans les temps',
    notInTime: 'Hors délai',
    rankWorld: 'Classement mondial',
    rankRegion: 'Classement région',
    rankRealm: 'Classement royaume',
    raidParses: 'Parses de raid',
    noRaidParses:
      "Aucun parse trouvé pour ce raid — soit le personnage n'y a pas encore loggé, soit la zone configurée est incorrecte.",
    boss: 'Boss',
    best: 'Meilleur',
    median: 'Médian',
    kills: 'Kills',
    metricDps: 'DPS (meilleur/médian)',
    metricHps: 'HPS (meilleur/médian)',
    metricBoss: 'DPS boss (meilleur/médian)',
    viewOnWarcraftLogs: 'Warcraft Logs',
    viewOnWowhead: 'Voir sur Wowhead',
    viewOnArmory: 'Armory',
    viewOnRaiderIo: 'Raider.IO',
    recentLogs: 'Derniers logs',
    noRecentLogs: 'Aucun log récent trouvé.',
    notConfigured: 'Non configuré par un administrateur.',
    highlightedLogs: 'Logs mis en avant',
    difficulty: {
      normal: 'Normal',
      heroic: 'Héroïque',
      mythic: 'Mythique',
    },
    selectPlayer: 'Pour quel joueur ?',
    newPlayerOption: '+ Nouveau joueur',
    newPlayerName: 'Nom du nouveau joueur',
    syncAll: 'Synchroniser tous les personnages',
    syncAllCooldown: 'Prochaine synchro dans {{time}}',
    sortByRaid: 'Raid',
    sortByMythicPlus: 'Mythique+',
    sortHint: 'Trier par',
    details: 'Détails',
    chooseDifficulty: 'Difficulté',
    bestSpec: 'Meilleur',
    viewSection: 'Affichage',
    dungeon: 'Donjon',
    heroMedia: 'Clip vedette',
    heroMediaHint:
      'Un GIF ou un court clip mp4 qui remplace le rendu quand cette carte est mise en avant.',
    heroMediaUpload: 'Envoyer un clip',
    heroMediaTooLarge: 'Les clips vedette sont limités à 20 Mo.',
    playClip: 'Lire le clip',
    pauseClip: 'Mettre en pause le clip',
  },
  feed: {
    title: 'Forum',
    subtitle: 'Memes, clips et exploits de guilde.',
    newPost: 'Nouveau post',
    postTitle: 'Titre',
    postBody: 'Message',
    tags: 'Tags',
    tagsHint: 'Sépare les tags par une virgule.',
    attachments: 'Pièces jointes',
    addLink: 'Ajouter un lien',
    linkUrl: 'URL du lien',
    dropzone: 'Glisse un fichier ici, colle une image ou clique pour parcourir.',
    dropzoneActive: 'Lâche pour ajouter le fichier',
    uploading: 'Envoi en cours…',
    publish: 'Publier',
    pin: 'Épingler',
    unpin: 'Désépingler',
    pinned: 'Épinglé',
    editedByAdmin: 'Modifié par un administrateur',
    comments: 'Commentaires',
    commentCount: '{{count}} commentaire',
    commentCount_other: '{{count}} commentaires',
    addComment: 'Écrire un commentaire…',
    send: 'Envoyer',
    deletePostConfirm: 'Supprimer ce post ?',
    deleteCommentConfirm: 'Supprimer ce commentaire ?',
    noPosts: 'Aucun post pour le moment. Sois le premier !',
    loadMore: 'Voir plus',
    searchPlaceholder: 'Rechercher dans le forum…',
    allTags: 'Tous les tags',
    react: 'Réagir',
    storageWarning: 'Le stockage est presque plein ({{percent}}).',
    storageFull: "Stockage plein — demande à un administrateur d'augmenter l'espace.",
  },
  media: {
    unsupportedType: 'Type de fichier non pris en charge.',
    fileTooLarge: 'Fichier trop volumineux (max {{max}}).',
    storageLimitReached: "Stockage plein — demande à un administrateur d'augmenter l'espace.",
    uploadFailed: "Échec de l'envoi.",
  },
  admin: {
    title: 'Administration',
    users: 'Utilisateurs',
    settings: 'Paramètres du site',
    roster: 'Effectif',
    addUser: 'Ajouter un utilisateur',
    role: 'Rôle',
    member: 'Membre',
    adminRole: 'Administrateur',
    active: 'Actif',
    inactive: 'Désactivé',
    deactivate: 'Désactiver',
    activate: 'Réactiver',
    promote: 'Promouvoir admin',
    demote: 'Rétrograder membre',
    resetPassword: 'Réinitialiser le mot de passe',
    newPassword: 'Nouveau mot de passe',
    impersonate: 'Se connecter en tant que',
    lastAdminError: 'Impossible de retirer le dernier administrateur.',
    siteTitle: 'Nom du site',
    publicRoster: 'Effectif public',
    publicRosterHint: "Si désactivé, l'effectif nécessite une connexion.",
    storageLimit: 'Limite de stockage',
    storageUsed: '{{used}} / {{limit}} utilisés ({{percent}})',
    storageLimitHint: 'Espace total alloué aux fichiers envoyés sur le forum.',
    wowRegion: 'Région WoW',
    wowRegionHint: "Région Blizzard / Raider.IO / Warcraft Logs des personnages de l'effectif.",
    warcraftlogsZoneId: 'Zone Warcraft Logs (optionnel)',
    warcraftlogsZoneIdPlaceholder: 'ex. 44',
    warcraftlogsZoneIdHint:
      'Laissé vide, Warcraft Logs choisit automatiquement le raid en cours pour chaque personnage — comme sur son propre site. Ne renseigner que pour forcer un raid précédent.',
    defaultTheme: 'Thème par défaut',
    defaultThemeHint:
      "L'identité visuelle de la guilde — vu par tout le monde tant qu'ils n'ont pas choisi leur propre thème.",
    createUserSuccess: 'Utilisateur créé.',
  },
  notifications: {
    title: 'Notifications',
    empty: 'Aucune notification.',
    markAllRead: 'Tout marquer comme lu',
    'post.created': '{{actor}} a publié « {{subject}} »',
    'comment.created': '{{actor}} a commenté « {{subject}} »',
    'reaction.created': '{{actor}} a réagi à « {{subject}} »',
    'storage.warning': 'Stockage : {{subject}}',
    system: '{{subject}}',
    new: 'Nouveau',
  },
  settings: {
    title: 'Paramètres',
    profile: 'Profil',
    displayName: "Nom d'affichage",
    avatarUrl: "URL d'avatar",
    language: 'Langue',
    theme: 'Thème',
    themeLight: 'Clair',
    themeDark: 'Sombre',
    themeAlliance: 'Alliance',
    themeHorde: 'Horde',
    themeVoid: 'Néant',
    themePoison: 'Poison',
    themeCustom: 'Personnalisé',
    customColors: 'Couleurs personnalisées',
    colorBg: 'Fond',
    colorSurface: 'Surface',
    colorText: 'Texte',
    colorAccent: 'Accent',
    colorAccentContrast: 'Texte sur accent',
    password: 'Mot de passe',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    changePassword: 'Changer le mot de passe',
    saved: 'Modifications enregistrées.',
  },
  errors: {
    validation_failed: 'Certains champs sont invalides.',
    unauthorized: 'Connecte-toi pour continuer.',
    invalid_credentials: 'Identifiant ou mot de passe incorrect.',
    forbidden: "Tu n'as pas la permission de faire ça.",
    not_found: 'Introuvable.',
    conflict: "Conflit avec l'état actuel.",
    payload_too_large: 'Fichier trop volumineux.',
    unsupported_media_type: 'Type de fichier non pris en charge.',
    storage_limit_reached: "Stockage plein — demande à un administrateur d'augmenter l'espace.",
    rate_limited: 'Trop de requêtes, ralentis un peu.',
    internal_error: 'Une erreur est survenue côté serveur.',
    bad_request: 'Requête invalide.',
  },
} as const;
